export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("@/views/dashboard/index"),
  },
  {
    path: "/rep-dashboard",
    name: "rep-dashboard",
    component: () =>
      import("@/views/schoolRepDashboard/schoolRepdashboard.vue"),
    meta: {
      title: "REP DASHBOARD",
      authRequired: true,
    },
  },
];
